import { useTranslation } from "react-i18next";

import { Button } from "common/components/ui/Button";
import {
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
} from "common/components/ui/Dialog";
import {
  Drawer,
  DrawerClose,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
} from "common/components/ui/Drawer";
import useTwBreakpoint from "common/hooks/useTwBreakpoint";

export default function ResetTargeting({
  isOpen,
  setIsOpen,
}: {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
}) {
  const { t } = useTranslation("campaigns");
  const isDesktop = useTwBreakpoint("lg");
  const isRemovingTargeting = false;

  const Component = isDesktop ? Dialog : Drawer;
  const Content = isDesktop ? DialogContent : DrawerContent;
  const Close = isDesktop ? DialogClose : DrawerClose;
  const Footer = isDesktop ? DialogFooter : DrawerFooter;
  const Header = isDesktop ? DialogHeader : DrawerHeader;

  return (
    <Component open={isOpen} onOpenChange={setIsOpen}>
      <Content>
        <Header
          title={t("targetingPreviewTitle")}
          subtitle={t("targetingPreviewSubtitle")}
        />

        <Footer className="justify-end">
          <Close asChild>
            <Button variant="outline-black" disabled={isRemovingTargeting}>
              Cancel
            </Button>
          </Close>

          <Button onClick={() => {}} isLoading={isRemovingTargeting}>
            Yes
          </Button>
        </Footer>
      </Content>
    </Component>
  );
}
